"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aclTranslationsPl = void 0;
exports.aclTranslationsPl = {
    // ACL Resources
    'acl_resource.company': 'Firma',
    'acl_resource.user': 'Użytkownik',
    'acl_resource.user_group': 'Grupa Użytkowników',
    'acl_resource.settings_general': 'Ustawienia Ogólne',
    'acl_resource.settings_access': 'Ustawienia Dostępu',
    'acl_resource.settings_styles': 'Ustawienia Stylów',
    'acl_resource.avatar': 'Awatar',
    'acl_resource.ai': 'AI',
    'acl_resource.knowledge': 'Wiedza',
    'acl_resource.project': 'Projekt',
    'acl_resource.onboarding': 'Wdrożenie',
    'acl_resource.reports': 'Raporty',
    // ACL Actions
    'acl_action.read': 'Odczyt',
    'acl_action.write': 'Zapis',
    'acl_action.delete': 'Usuń',
};
